// src/firebase.ts
import {initializeApp } from "firebase/app";
import {getFirestore, serverTimestamp } from "firebase/firestore"; // Import serverTimestamp from firestore
import {getFunctions, httpsCallable } from 'firebase/functions';
import {getAuth, RecaptchaVerifier, signInWithPhoneNumber} from "firebase/auth";
import {getStorage} from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBFV0ydZ8LWF4afnzmfGir5PSO2qLB2T0g",
  authDomain: "grema-62003.firebaseapp.com",
  projectId: "grema-62003",
  storageBucket: "grema-62003.firebasestorage.app",
  messagingSenderId: "432558837127",
  appId: "1:432558837127:web:68e007ce6fe32dfb67d722"
};

const app = initializeApp(firebaseConfig);

export const storage = getStorage(app);
export const db = getFirestore(app);
export const firebaseAppId = firebaseConfig.appId;
export const functions = getFunctions(app);
export const auth = getAuth(app);
export {serverTimestamp }; 
export {RecaptchaVerifier, signInWithPhoneNumber };

